import { render, staticRenderFns } from "./CriarFonte.vue?vue&type=template&id=0e2a874a&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./CriarFonte.vue?vue&type=style&index=0&id=0e2a874a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2a874a",
  null
  
)

export default component.exports